<template>
  <!-- eslint-disable -->
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead01">
                <div class="inner4">
                    <h1><img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/title.png" srcset="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/title@2x.png 2x" alt='僕らの写真時代' /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2022年9月16日（金）～9月19日（月・祝）、東京・渋谷ヒカリエにて「東京カメラ部2022写真展」が開催されました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            9月17日（土）に行われたキヤノンマーケティングジャパンのトークショーでは、写真家 鈴木さや香氏、キヤノンマーケティングジャパンの斉藤舞子氏にご登壇いただき、「僕らの写真時代」というテーマでお話しいただきました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/01.jpg" alt="キヤノンマーケティングジャパン 01" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            東京カメラ部運営 塚崎（司会）「みなさん、こんにちは。本日はおふたりのスペシャルゲストをお迎えして『僕らの写真時代』と題したトークショーを開催させていただきたいと思います。おふたりのご紹介をさせていただきます。写真家の鈴木さや香さんです」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/02.jpg" alt="キヤノンマーケティングジャパン 02" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「もうひとりのゲストはキヤノンマーケティングジャパン株式会社の斉藤舞子さんです。斉藤さんはキヤノンギャラリーのご担当を経て、現在は会員制フォトコミュニティ『キヤノンフォトサークル』の運営、月刊雑誌『キヤノンフォトサークル』の企画制作やイベント企画など、メーカーの立場から写真文化の発信をされています。斉藤さんは写真の勉強もなさっているそうですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/03.jpg" alt="キヤノンマーケティングジャパン 03" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            斉藤「本日はよろしくお願いします。2年ほど前に写真の勉強をしたくて大学院に行き、修士論文も書かせていただきました」<br><br>

							鈴木「彼女は、たぶん、わたしが写真について困ったときに、いちばんに見せる人です。写真を撮らないのですが、撮らない人の目線ってものすごく俯瞰的なので非常に重要です。撮っている人の目線は、わたしはこれは撮らないなとか、どういうふうに撮ったんだろうという目線で見がちですが、彼女はもう少し本質的な部分で写真を見てくれるから、写真で困ったときに連絡し、客観的に見てもらうことがあります」<br><br>

							塚崎「写真家がアドバイスを求める人ということですね」<br><br>

							斉藤「そう言われるとたいそうなことをしているみたいですが、素直に感想を伝えるようにしているだけなんです」<br><br>

							鈴木「大事なことなんですよ。核は自分で決めるにしても、発表の前に、伝わりかたや、見た人がどうとらえるかを伝えてもらえることは、多角的に見れる大事な過程です。発表したら、作品はひとりでどんどん進んでしまいますので」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/04.jpg" alt="キヤノンマーケティングジャパン 04" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
							塚崎「このメンバーで『僕らの写真時代』という、カメラではなく写真をテーマにお話したいと思っています。さや香さんとお会いするのは久しぶりですよね」<br><br>

							鈴木「そうですね、以前は、東京カメラ部の事務所がうちの近所にあったので、お店に来ていただいたりしていて」<br><br>

							塚崎「ランチをするコース上にあり、よく立ち寄らせていただいていました」<br><br>

							鈴木「舞子さんもよくお店に来てくれて、写真を買ってくださったりしていて。わたしが写真の封筒を作りはじめたときの、たぶん最初のほうのお客さんが彼女で、彼女に買ってもらったことがわたしの自信に繋がったという感じです」<br><br>

							斉藤「うれしいです、そう言っていただいて」<br><br>

							鈴木「いつだったか、舞子さんはお母さんと喧嘩したから、さや香さんの封筒を買ってプレゼントすると言ってくださったのが本当にうれしくて、2013年頃からの付き合いですかね。お酒を飲みながら写真の話をするような旧知の仲です」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/05.jpg" alt="キヤノンマーケティングジャパン 05" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「今日はそんなおふたりが普段お話されているような内容をここでもご紹介できればと思っております。（鈴木さんのお店）アトリエピッコロの店内と今回のキヤノンさんのブースは似ていますよね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/06.jpg" alt="キヤノンマーケティングジャパン 06" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            鈴木「はい＾＾ピッコロがやって来たような感じにしています。今回は『和紙とかも自由に使って、さや香さんの好きな空間にしてください』と言っていただき、EOS R10で撮影した撮り下ろしの写真を使い、わたしが大事にしているものを共有できるような空間にしています。個展を依頼していただける写真家になるのが夢だったので、今回それが叶いました。さまざまな紙を使い分けて展示をしているので、プリントのおもしろさも見ていただきたいです」<br><br>

							斉藤「安心できるような空間になっていると思います。写真は見るものではありますが、空気感を感じていただけるブースになっているはずです。キヤノンとさや香さんが大切にしているものが詰まっていると思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/07.jpg" alt="キヤノンマーケティングジャパン 07" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「いま『感じる』という言葉が出てきましたが、いまの『写真時代』に対して感じていること、おふたりがこの時代に写真の仕事に携わる意義はどこにあるのでしょうか」<br><br>

							鈴木「・・・ちなみに塚崎さんは、なぜこんなに写真を大切に感じていらっしゃるのですか？」<br>

							塚崎「まさかの質問返し（笑）。もともと僕はソニーでウォークマンの開発などに携わっていました。音楽は演奏する方より圧倒的に聴くだけの方が多いと思うんですよね。この会場の中でも、今年に入って何曲か演奏してきたよ、という方はたぶん少ないと思います。しかし、写真を今年に入って1枚も撮っていないという方はおそらくほぼいない。つまり、写真は誰もが作る、表現者になれるのです。人類史上、最も参入障壁の低い自己表現手段ではないかと思っていて、その点におもしろさを感じていまの仕事に取り組ませていただいています」<br><br>

							鈴木「そうですね、たくさんの方が表現者になっていますよね。カメラを持った方の多くは自分は素人だとか、カメラマンなんてとてもじゃないと思っているかもしれないですが、カメラを持った時点で、その人は写真家だと思うんです。アマチュアかプロかではなくて、表現者として写真に責任を持つべきで、考えていかなければならないと思います。この写真は誰かを傷つけるかもしれないとか、これは必要ない写真かもしれないとか、そういうことを全員が考えられたらもっといいですよね。それと同時に、写真表現の自分らしいテイストや視点をどのように作っていくべきか悩む人も多いと思うので、少し脱線しますが、わたしが自分のテイストを作ったときの話をしていこうと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/08.jpg" alt="キヤノンマーケティングジャパン 08" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            鈴木「わたしは大学を卒業する前からテレビの世界に入りました。ADやAPをやっていると自分の視点というのは関係なくて、演出家やプロデューサーの考えをいかにサポートできるかが大事でした。そのあと、写真の師匠である山岸伸さんのアシスタントになり、そこでも山岸さんがどういうことを考えているのかを日々考えて30歳を迎えてしまいました。つまり、10年間くらい、自分のことではなく人の頭の中を考える生活をしていたんですよね。だから、いざ独立をしたときに、自分には“視点”が少ないわけです。カメラは使えます。アートディレクターがいれば、その要望に沿って光を作って撮ることもできます。広告写真を撮影する場合はそれで成り立つ場合も多いですが、作品を提供してくださいと言われたときにすごく困ったんですね。そこで、自分のテイストを探すために、まず“目的”を考えました。例えば一般的には、SNSで有名になりたいというのもひとつですし、アートと呼ばれるものとして世界に広がっていきたいというのもそう。その中でわたしは、『世界の人々の家の中に自分の写真がある状態を作りたい』と思ったんです。誰かの家に写真がある状態を考えたときに、すごく尖った写真だったら嫌だろうなと思って、丸くて、温かくて、作り手の想いを感じるようなじんわりした写真を目指そうとテイストを作っていきました。でも、カメラで撮影するだけではそこには到達できないと思ったので、プリントを本当にたくさんしたんです。稼いだお金も全てプリントにつぎ込んだからご飯が食べられなくなって、どんどん痩せていってしまって、そのくらいプリントをしていたら、なんだか見えてきてしまったんですよ。そして、アトリエピッコロを作ってプリントを売っていたら、お客さんからさまざまな声をいただいて、家に飾る写真はどういうテイストがいいのかについて、また考えていくうちに、いまのわたしのテイストが完成したんです。だから、テイストや視点で迷っている人がいたら、それは自分の足元からしか生まれないものなので、一度自分が写真を撮る目的を考えてみると見つかりやすいのかもしれません」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/09.jpg" alt="キヤノンマーケティングジャパン 09" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            斉藤「さや香さんのいまの視点の話ですが、たしかにたまにしか自分の写真を見ないと、自分が何を大切にしたいのかに気付けないと思うんですね。日々の中に、空気のような当たり前の存在として壁にかかっていたり、自然に目に入るような場所に自分のプリントを飾ってみると、撮りたかったものだけど本当は好きではないのかもとか、この写真はなぜか好きだな、みたいな新しい視点に気付けるように思うんです。ですから、さや香さんの写真と生活を結びつける試みは素敵だなと思います」<br><br>

							鈴木「わあ、うれしいです。写真はレタッチの有無も含めて創り出すっていう事かなと思います。もちろん、加工しないという生のような写真は鮮度を感じさせてくれるので、表現方法として大切です。でも、レタッチをする・しないというバランスも表現ですごく重要なんです。レタッチは目的があるからすると思うんですけれど、展示作品やSNSによってレタッチのやり方は変わるので、その都度レタッチの内容は変えていくことが望ましいです。調整することは悪いことじゃない。雲を虹色にするとかの極端な例は別ですが、作品ごとに味をつけて、自分の個性を見つるのは大切だと思います」<br><br>

							塚崎「ありがとうございます。少し話を戻して、斉藤さんがいま写真の仕事に携わるうえで意識されていることはありますか？」<br><br>

							斉藤「意識しているというほど大げさなことではないかもしれませんが、いまは誰もが写真を使った表現者になれるという話が出ましたよね。『見る』という方向からもそれは言えることで、『今日一日写真を見ないで過ごしてください』と言われても、それは不可能だと思うんです。日常の中に写真があることが当たり前になりすぎると、大切なものに気付けなくなっていきます。せっかく生み出された写真の大切さに気付けなくなることは残念なこと。カメラで生み出された写真とどうやって付き合っていけば幸せになれるんだろうということを、わたしは常に考えています。大学院でも、写真に囲まれたこの地球で、どう幸せに生きていくかという人類学的な要素も含めて取り組んでいました」<br><br>

							塚崎「写真と暮らしという内容ですね。まさにさや香さんがやられている『写真と暮らし研究所』と通じるところですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/10.jpg" alt="キヤノンマーケティングジャパン 10" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            鈴木「全ての場面で写真が関わってくる時代になっているからこそ、取捨選択を自分でしないといけなくて、ときには写真に撮らない美しさというのもあると思うんですね。秘めておくみたいな。そういうことも自分で見つけていくことを提案する会社として作ったんですが、やっと時代が追い付いてきたと感じましたね。笑」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/11.jpg" alt="キヤノンマーケティングジャパン 11" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「撮る・撮らないもありますし、撮った写真をどう表現するのか。レタッチする・しないもありますし、プリントをする・しないということもあります。そういったことを研究所ではお考えになっているのですか？」<br><br>

							鈴木「そうですね。結局、人間ができることってそんなに多くないと思うので、その3個くらいを考えていれば、回り回って自分というものが現れるのかなと思います。『撮る』ということをするならば、発表する・しない、表現をどうするか、何をつたえたいのか、これらをまとめて請け負わないと無責任かなと思っていて、それはプロだからアマチュアだからじゃなくて、表現者には必要なことだと思っています。例えば一つの表現で、レタッチをしすぎると、現実と離れていき、メルヘンやファンタジーになると思いますが、そうするにしても作品の軸は必要だと思うんです。軸っていうのは、自分がどういうことを伝えたいのかということですね。コンセプトです。会話に置き換えると、『なに食べたい？』と聞いたときに『お好み焼きかな』というのが普通の会話ですよね。でも、ファンタジーが多めだと『君の笑顔がまぶしすぎて食べられないな』と返答して会話しているようなものです。毎回のように『夜空を駆け抜けて虹を食べよう』とか言われていたら何がいいたいのか分からないですよね。メルヘンやファンタジーはあっていいけれど、軸というものはしっかりとあったうえで、っていうのが伝えるっていうことかなって思います。写真も同じことですね、伝えるものなので」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/12.jpg" alt="キヤノンマーケティングジャパン 12" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「斉藤さんも写真を見るときには『軸』のようなものがあるのですか？」<br><br>

							斉藤「軸をつねに探している感じです。『この写真が好きだな』『この写真が嫌いだな』と思うことは正直あります。ですが、わたしは全部の写真を好きになる必要はないと思っていて、自分の好き嫌いがわかるところにもその写真を見る価値があると思うんです」<br><br>

							鈴木「舞子さんは好きだから好きとか、嫌いだから嫌いだけじゃなくて、何をこの写真は言おうとしているのかというのをすごく探すんですよ。『この写真はこういうことだと思う』ということを、うわべの表現だけを見ずに考えてくれますね」<br><br>

							斉藤「写真を撮った人の意図は絶対にあると思いますが、見る側がそれをどう受け取るかは自由なので意図は意図として、そこにわたしがどういう思考を巡らせたかということが大切で、わたしはわたしの言葉で伝えることで、それが自分の軸としてだんだんと作られている感覚です」<br><br>

							塚崎「つまり軸はあるということですね」<br><br>

							鈴木「そう、舞子さんは軸があるんです（笑）。舞子さんほどプロ写真家のプリントを見た人はいないんじゃないかくらいで、わたしの何倍も見ているし、大御所のプリントを見ているし、そうなると『わかりません』なんて言えないじゃないですか。自分の軸を行ったり来たりしている割には、すごい俯瞰ポイントを持っていますね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/13.jpg" alt="キヤノンマーケティングジャパン 13" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            塚崎「ご自身で写真を撮らないというところがおもしろいですね。わたしも写真家の方と共にフォトコンテストの審査をする機会も多いですが、どうしても写真家の場合『これ撮るのは簡単だから』とか『ここ駐車場から5分で行ける場所だよね』とか、写真の善し悪しの前に、その写真を撮る前の苦労がどうしても審査結果に入り込むこともあります」<br><br>

							鈴木「わかりますそれ。自分の経験値で評価する人はいますが、その写真がその人にとってどういうものだったかを汲み取ることも必要なのに」<br><br>

							塚崎「ですから、ポートレートを風景写真家の方が審査すると、そういうことは起きない。『逆も真なり』ということですよね」<br><br>

							鈴木「昔はカメラも高く、そもそも写真というものがものすごい苦労の積み重ねで発表されるものだったから、その戒めのようなものもあるのかなと思いますね。でも、写真自体はどんどん変化していて、変わってはいけない部分もあれば、みんなが表現者というところなど変化すべきところはある気がしますね」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/14.jpg" alt="キヤノンマーケティングジャパン 14" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「いま、斉藤さんは『たくさんの巨匠のプリントを見ている』とお聞きしましたが、それはどういうことでしょうか」<br><br>

							斉藤「以前は銀座のキヤノンギャラリーを担当していたので、多くの写真を見る機会がありました」<br><br>

							塚崎「そういうものに触れていたからこそ、作品のテーマだったり、写真と暮らしということなどに思い至るようになったのではないでしょうか」<br><br>

							斉藤「どうなんでしょうか。わたしがたくさん見ているのと同時に、皆さんもたくさん見ているな、ということには気付けたのかもしれません」<br><br>

							鈴木「こういうところですよね、彼女の俯瞰ポイントは。撮ることに夢中になりがちですが、実は、本当に驚くほどの量の写真を皆さんも見ているじゃないですか。もうちょっと見ることについても考えられるような世の中になればいいなって思いますね。そうすると、撮ることにもうまく働くと思いますし、別のことをするときにもプラスになるだろうなって」<br><br>

							塚崎「スマホを持っているだけでも、凄まじい量の写真が流れてきますよね。それを見る時間は1枚あたりすごく短い。一方でこの会場には企画展を含めれば1000枚を超えるプリントが展示されていますが、スマホの画面よりも少しは長く見ていただいていると思うんですね。1枚あたりを見るのに費やす時間の長さで、きっと写真の見え方は変わってきます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/15.jpg" alt="キヤノンマーケティングジャパン 15" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            鈴木「たしかに、見るサイズの違いも影響ありますよね。あと見る距離でも変わります。おもしろい話をすると、キヤノンのブースで展示されているわたしの作品たちは、解像度の良いキレキレの機材で撮ったものもあれば、マルミ光機さんと作ったわざと解像度を落とすフィルターを付けて撮ったものもあります。でも、どれがフィルターで撮ったものかを全て当てることができる人は、たぶんひとりもいないんじゃないかなと思いますし、わたしも自分は解像度でまわりを見ていないんだという事に気づきました。広告用や対象物をきちんと見せる写真は、解像する機材が必須ですが、例えば、プライベートな写真だったら、寝る前に思い出すときのような、全く鮮明じゃない視点でまわりを見ていても表現が膨らむかもしれません。説明じゃなくて自分が考える余地が出てくる。解像感を使い分けることで、もっと人生の見え方が楽しくなってくるんじゃないかなと思います」<br><br>

							塚崎「レタッチには色味などだけでなく解像感も含まれるという感覚ですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/16.jpg" alt="キヤノンマーケティングジャパン 16" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            鈴木「そうです。そしてプリントもある種そういう部分があります。画像とは違う解像感と質感で出てくるものだから、こういうふうに見えるのか、という客観的ポイントがプリントで見えるというところもあるので、もし写真を撮る、見せることに困っている人がいたら、使ったことのない紙でプリントをしてみると、客観的にいろいろと見えるかなと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/17.jpg" alt="キヤノンマーケティングジャパン 17" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            斉藤「カメラもどんどん進化していて、解像度の高いカメラを各社出していますけども、じゃあ高解像を使うのか使わないのかという選択は自由であって、例えば自分が落ち込んでいる日に外に出たとしたら、自分は落ち込んでいるわけだから世界なんてどうでもいいじゃないですか。幸せな人なんてはっきり見たくない。だったらそのときに撮る写真はボケてていいんですよね。高解像である必要はなくて、光が涙でハッキリ見えないならそれでいいと思うんですね。それこそが撮影者がそのときに見ていた光景。さや香さんの目には、そんな解像度が設定されているんじゃないかと思うことが多々あります」<br><br>

							塚崎「解像感には上下があってよくて、クッキリと撮るには高い解像度は必要になりますし、涙が出ているようなときには下げることができるという、そういう幅を選ぶことができる時代になったのかもしれませんね」<br><br>

                            鈴木「そう、あらゆることを自分で選ぶ時代になったと思うんですよ。これがいいよって提供されるものだけを信じるんじゃなくて、自分で大切なものを集めていくという時代なのかなって思います」<br><br>

							塚崎「表現者の時代ということかもしれません。自分の好きな色味や解像感を選ぶことができる。しかし、自由になりすぎることで迷子にもなります」<br><br>

							鈴木「そうですね、迷子になったときにどうするかという話。そういうときはまずは、自分のことをよく知るということでしょうね。そのためには多角的に見てみるといいと思うので、小説を読むとかもいいかもです。写真ばかりを見るんじゃなくて、さまざまな情報を採り入れることが自分の考え方を見つけていくのに大事ですね」<br><br>

							斉藤「わたしも小説を読むのも、映画を見るのも大好きです。そういうところで自分の感性に気付くこともあるじゃないですか。わたしは写真を撮りませんが、撮る方がそういう行為をすることで、撮った写真が変わることはあると思います。写真集などを見て勉強をされている方も多いと思いますが、いったんはそういうところから離れて、全く違うものを見ると、写真も変わるのではないかと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
				
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/19.jpg" alt="キヤノンマーケティングジャパン 19" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            鈴木「好きなことばかり追いかけてもね、と感じることがあって、制限も個性のうちだと思うのです。夫は写真が嫌いなんですよ。カメラを向けることはピストルを向けることと同じだと思っていて。わたしは日常の写真の本まで書いているのに、彼のテリトリーを犯さないように、細心の注意を払って日常を撮っていて、でもそれが私の個性にもなっていると感じているんです」<br><br>

							塚崎「だから、生活の一部を切り取ったような作風になっているのですね。隙間から見ているかのような」<br><br>

							鈴木「説明しようとすると彼のテリトリーが入ってしまうので、なるべくタイトに自分の半径2メートルくらいの世界を切り取っていこうと思っていて、そこに息子が入ってきたり彼がたまたま入ってきたら写ってしまいますが、できるだけ熱がないように、傷つけないように撮ろうと心掛けています。でも、こういう制約があるのはいいことだと思うんです。『写真が好きだから、撮りたいから撮る！』というような状況ならこういう写真は生まれないはずで、なるべく傷つけないように撮っているから今の写真になっているんだと感じますね」<br><br>

							斉藤「撮影って『shoot』っていうじゃないですか。動物を狩るというのも同じく『shoot』って言うんですよね。写真を撮る行為は被写体を狩っているのと似た側面があるのかもしれません。さや香さんが冒頭におっしゃっていた『表現者としての責任』というものは、こういう制約から生まれていったんだなと感じました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/20.jpg" alt="キヤノンマーケティングジャパン 20" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
							鈴木「どこかに行こうと思えば行ける世の中に戻りつつありますが、コロナ禍ではそうはいきませんでした。わたしが身の回りのものを撮るようになったのは、子どもがお腹に宿った時、どこか遠くにしばらくは行くことはできないと思ったからなんですが、最初は子どものための日記のようでした。けれども、日常の写真を作品にできるかもしれないと思ったのは、映画『モリのいる場所』や『幸せの絵の具』など、主人公が、狭くとも小宇宙のような場所で創作している物語を見て、手が届く大事にしている範囲でどれだけ発見をできるかによって世界は無限に広く感じられると改めて思ったんです。自分自身、『家が狭い』と思うのではなく『家は広い』と感じたいし、見てくれる人にそういうメッセージを込めたいと思って。だから日常写真は素敵だなと思って作品にできると思ったのです」<br><br>

							塚崎「奇しくも今年のテーマは『写真との出会いは、世界との出会いだ。』というものなんです。大冒険をしようというわけではなく、日常の中にさまざまなものが潜んでいて、写真を撮ることはそれらを探すことで、そうすると足元の花に気付けるかもしれないし、猫に元気がないということに気付けるかもしれない。通り過ぎるのではなく、撮ることでこれほど美しいものが潜んでいることに気付ける、というのが写真じゃないのかなと思います」<br><br>

							斉藤「わたしが担当している『キヤノンフォトサークル』という雑誌の特集で、『半径5メートル以内の広い世界』という特集名を付けたことがあるんです。それはいまの話と同じことで、半径5メートルというのは自分のプライベートな空間であるにも関わらず、そこをあまり見ないで海外に行って写真を撮る方も多いと思います。それもまた楽しくて素敵なことですが、5メートル以内のことって意外と知らないことが多いんですよね。改めて5メートル以内を見返すと、海外に行くよりももっと自分の世界は広がるんじゃないかなと思っていて、その可能性を教えてくれたのはさや香さんの写真がきっかけでもあるんです。さや香さんの写真に、まな板の上にシメジが転がっているものがあって、それを見たときにシメジがかわいいと思ったんです。そのときに、シメジを見てわたしはかわいいと思うんだ、ということがわかって、その体験もかなりのきっかけだった気がしています」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/23.jpg" alt="キヤノンマーケティングジャパン 23" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
							塚崎「写真を撮らなくてもそういうことに気付けるのですね」<br><br>

							鈴木「気付ける人だからこそ、撮らないのかもしれませんね＾＾」<br><br>

							塚崎「そんなさや香さんの作品はキヤノンのブースに展示されていますが、展示というより生活がそこに再現されていますので、ぜひ見ていただければと思います。そして写真に迷いがある方は、プリントをすることで気付けるというお話もありましたが、無料プリントを体験できるコーナーもありますので、ぜひ試していただきたいと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/21.jpg" alt="キヤノンマーケティングジャパン 21" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
							斉藤「ぜひキヤノンブースに来ていただきたいです。そして持ち帰っていただいたプリントは、ぜひ視界に入る壁に飾っていただき、新たな写真の良さに気付いていだけるとうれしいです」<br><br>

							塚崎「ようやくオフラインでの開催となりましたので、ぜひプリントを実体験していただければと思います。本日は短い時間でしたが、ありがとうございました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
								
                <section class="profile">
                  <div class="inner2 clearfix">
                    <div class="left"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/22.jpg" alt="鈴木さや香さん"></div>
                    <div class="right">
                        <h3 class="profName" style="word-break: break-all;;">鈴木さや香</h3><h4 class="profNameSub">Sayaka Suzuki</h4>
                        <p class="profTxt">
                          <span style="white-space: pre-wrap;">
                          東京京造形大学環境造形学部デザイン科卒業、研究生過程修了。<br>
                          空間デザインを学びCMやTVの映像制作の現場を経て、写真の道へ。<br>
                          日常にやわらかく焦点をあてた作品から広告写真まで幅広く撮影する。<br>
                          写真家として活動する一方で、写真のプリントを飾る、活用する事を提案する<br>
                          アトリエピッコロ(鎌倉／店舗)を営む。<br>
                          またマルミ光機との共同開発でフィルター「アルプスパンチ！なついろパンチ！」を製作。<br>
                          近著に、日常写真を楽しむノートブック／インプレス出版 がある。</span>
                        </p>
                    </div>
                  </div><!-- /inner-->
                </section><!-- /profile-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <div class="actionMenu">
        <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.report .reportVhead01{
    background-image: url("https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/canon/titleBk.jpg");
    background-repeat: no-repeat;
    background-position: top center;
}
.natgeoLinkArea {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
}
.natgeoLinkArea div {
    width: 43%;
    margin-bottom: 24px;
}
@media screen and (max-width:640px){
    .natgeoLinkArea {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .natgeoLinkArea div {
        width: unset;
        margin: 24px 16px;
    }
}
</style>
